import React from "react";
import {
  CardContainer,
  InnerCardContainer,
  TypographyBold,
  ImageBadge,
} from "./NewCard.styled";
// import Text from "../Text"
import { func } from "../../../utils";
import { usePageContextState } from "../../../context/PageContext";
import useWindowSize from "../../../hooks/useWindowSize";

const Card = ({
  text = "",
  srcImg = ``,
  onClick,
  backgroundColor,
  className,
  bypassIsLive = false,
}) => {
  const { isLive } = usePageContextState();
  const { size } = useWindowSize();

  const isMobileView = (size?.width || 0) <= 769;

  return (
    <div>
      <CardContainer
        className={className}
        onClick={onClick}
        backgroundColor={backgroundColor}
        img={func.getStaticImg("/bg/bg-card-home-detail.png")}
        width={
          isMobileView
            ? isLive
              ? "152px"
              : "102px"
            : isLive
            ? "200px"
            : "134px"
        }
        height={
          isMobileView ? (isLive ? "50px" : "90px") : isLive ? "72px" : "108px"
        }
      >
        <InnerCardContainer
          flexDirection={isLive || bypassIsLive ? "row" : "column"}
          alignItems={isLive || bypassIsLive ? "center" : "start"}
          alignSelf={isLive || bypassIsLive ? "center" : "flex-start"}
        >
          <ImageBadge src={func.getStaticImg(srcImg)} />
          <TypographyBold>{text}</TypographyBold>
        </InnerCardContainer>
      </CardContainer>
    </div>
  );
};

export default Card;
